import { motion } from 'framer-motion';
import { useMontessoriTheme } from '@/contexts/ThemeContext';

const LEAVES = ['🍃', '🌿', '🍂', '🌱'];

export function FloatingLeaves() {
  const { isMontessori } = useMontessoriTheme();
  if (!isMontessori) return null;

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
    >
      {Array.from({ length: 7 }).map((_, i) => {
        const left = (i * 13 + 7) % 95;
        const size = 22 + (i % 3) * 8;
        const duration = 22 + (i % 4) * 4;
        const delay = (i % 5) * 2.4;
        const drift = (i % 2 === 0 ? 1 : -1) * (20 + (i % 3) * 12);
        return (
          <motion.span
            key={i}
            initial={{ y: -40, x: 0, rotate: 0, opacity: 0 }}
            animate={{
              y: ['0vh', '105vh'],
              x: [0, drift, -drift / 2, 0],
              rotate: [0, 90, 180, 270, 360],
              opacity: [0, 0.7, 0.7, 0],
            }}
            transition={{
              duration,
              delay,
              repeat: Infinity,
              ease: 'linear',
            }}
            style={{
              position: 'absolute',
              left: `${left}%`,
              top: 0,
              fontSize: size,
              filter: 'drop-shadow(0 2px 4px rgba(125, 107, 74, 0.15))',
            }}
          >
            {LEAVES[i % LEAVES.length]}
          </motion.span>
        );
      })}
    </div>
  );
}
